import { useMutation } from "@tanstack/react-query";

import { postMobility } from "../api/mobility";

const usePostMobility = () => {
  const mutation = useMutation({ mutationFn: postMobility });
  return mutation;
};

export default usePostMobility;
